import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        login: {},
        listForExchange: {},
        statement:[],
        active:{},
        courses:[],
        semesters:[],
        listOfBooksById: [],
        listOfEbooksById: [],
        semesterCoursesArray: [],
        semesterData: [],
        checkedBooks:{},
        points:[],
        match:[],
        courier:{},
        pinFlag:'',
        statementBookGroup:{},
        exchangeType:{},
        courierInfoFlag: false,
        finalDeclarationflag:false,
        chooseCourierButton: false,
        loadingModal: false,
        bookExchangeFlag: {},
        bookSelect: {},
        exchangeStudentData:{},
        listOfExchangeBooks: [],
        activeDeclaration: false,
        statementComplete: {},
        redeemPoints: {},
        avaliableCredit: 0,
        messageModal: false,
        bookInfoModal: {},
        tooltipBookId:{},
        messageObject: {},
        errorMessageModal: false,
        errorMessageObject: {},
        initializationFlag: false,

        booksFromCheckedByDistPoint: [],
        booksFromCheckedByCourrier: [],
        booksFromRedeemByDistPoint: [],
        booksFromRedeemByCourrier: [],

        eudoxusTitle: 'Eudoxus Greece',
        studentFirstName: 'Ξενοφων',
        studentLastName: 'Καρύδης',
        courierInfo: {},

        newStatementAllow: false,

        completeDialog: false,
        informationDialog: false,
        searchDialog: false,

        checkDialog: false,
        //Terms & Condition Vars
        checkedTerms: false,
        checkedDegree: false,
        certificateDialog: false,
        exchangeDialog: false,

        counterDelivered: 0,
        counterReturnedToLibrary: 0,
        counterPassedToStudent: 0,
        counterExchangeable: 0,
        totalWronglyDeliveredBooks: 0,

        statementIsComplete: false,
        selected: [],
        linkedSemesterData: {},
        listLinkedEbooks: [],
        submitInformationDialog: false,
        bookExchange: {},
        solarResponse : [],
        pendingEvaluationShow: false,
        exchangeTypeComponentFlag: false,
        courseRegistration: [],
        studentAddressInformation: true,
        statementAddress: {},
        courseCodeHashMap: {},
        vouchersDialog:false,
        newIssueDialog:false,
    },

    getters: {
        studentFullName(state) {
            return state.studentFirstName + ' ' + state.studentLastName
        },

        errorCheck: state => {
            return state.checkedTerms === true && state.checkedDegree === false
        },

        checkedTerms: state => state.checkedTerms,
        checkedDegree: state => state.checkedDegree,
        certificateDialog: state => state.certificateDialog,
        exchangeDialog: state => state.exchangeDialog,
        checkDialog: state => state.checkDialog,
        newStatementAllow: state => state.newStatementAllow,
        completeDialog: state => state.completeDialog,
        informationDialog: state => state.informationDialog,
        searchDialog: state => state.searchDialog,
        courierInfo: state => state.courierInfo,
        login: state => state.login,
        listForExchange: state => state.listForExchange,
        courses: state => state.courses,
        semesters: state => state.semesters,
        listOfBooksById: state => state.listOfBooksById,
        listOfEbooksById: state => state.listOfEbooksById,
        semesterCoursesArray: state => state.semesterCoursesArray,
        semesterData: state => state.semesterData,
        checkedBooks: state => state.checkedBooks,
        statement: state => state.statement,
        points: state => state.points,
        match: state => state.match,
        courier: state => state.courier,
        active: state => state.active,
        pinFlag: state => state.pinFlag,
        statementBookGroup: state => state.statementBookGroup,
        exchangeType: state => state.exchangeType,
        courierInfoFlag:state => state.courierInfoFlag,
        finalDeclarationflag:state => state.finalDeclarationflag,
        chooseCourierButton:state => state.chooseCourierButton,
        loadingModal: state => state.loadingModal,
        bookExchangeFlag: state => state.bookExchangeFlag,
        bookSelect: state => state.bookSelect,
        exchangeStudentData: state => state.exchangeStudentData,
        listOfExchangeBooks: state => state.listOfExchangeBooks,
        activeDeclaration:state => state.activeDeclaration,
        statementComplete: state => state.statementComplete,
        redeemPoints: state => state.redeemPoints,
        avaliableCredit:state => state.avaliableCredit,
        messageModal: state => state.messageModal,
        bookInfoModal: state => state.bookInfoModal,
        tooltipBookId: state => state.tooltipBookId,
        messageObject: state => state.messageObject,
        errorMessageModal: state => state.errorMessageModal,
        errorMessageObject: state => state.errorMessageObject,
        booksFromCheckedBySecretariat: state => state.booksFromCheckedBySecretariat,
        booksFromCheckedByDistPoint: state => state.booksFromCheckedByDistPoint,
        booksFromCheckedByCourrier: state => state.booksFromCheckedByCourrier,
        booksFromRedeemBySecretariat: state => state.booksFromRedeemBySecretariat,
        booksFromRedeemByDistPoint: state => state.booksFromRedeemByDistPoint,
        booksFromRedeemByCourrier: state => state.booksFromRedeemByCourrier,
        initializationFlag: state => state.initializationFlag,
        counterDelivered: state => state.counterDelivered,
        totalWronglyDeliveredBooks: state => state.totalWronglyDeliveredBooks,
        counterReturnedToLibrary: state => state.counterReturnedToLibrary,
        counterPassedToStudent: state => state.counterPassedToStudent,
        counterExchangeable: state => state.counterExchangeable,
        statementIsComplete: state => state.statementIsComplete,
        selected: state => state.selected,
        linkedSemesterData: state => state.linkedSemesterData,
        listLinkedEbooks: state => state.listLinkedEbooks,
        submitInformationDialog: state => state.submitInformationDialog,
        bookExchange: state => state.bookExchange,
        solarResponse: state => state.solarResponse,
        pendingEvaluationShow: state => state.pendingEvaluationShow,
        exchangeTypeComponentFlag: state => state.exchangeTypeComponentFlag,
        courseRegistration: state => state.courseRegistration,
        studentAddressInformation: state => state.studentAddressInformation,
        statementAddress: state => state.statementAddress,
        courseCodeHashMap: state => state.courseCodeHashMap,
        vouchersDialog: state => state.vouchersDialog,
        newIssueDialog: state => state.newIssueDialog,
    },

    mutations: {
        setCheckedTerms: (state, flag) => {
            state.checkedTerms = flag
        },
        setCheckedDegree: function (state, flag) {
            state.checkedDegree = flag
        },
        setCertificateDialog: function (state, flag) {
            state.certificateDialog = flag
        },
        setExchangeDialog: function (state, flag) {
            state.exchangeDialog = flag
        },
        setFullName: function (state) {
            state.studentFirstName = "Γεια σου κ. "
        },
        setDialog: function (state, flag) {
            state.checkDialog = flag
        },
        setNewStatementAllow: function (state, flag) {
            state.newStatementAllow = flag
        },
        setCompleteDialog: function (state, flag) {
            state.completeDialog = flag
        },
        setInformationDialog: function (state, flag) {
            state.informationDialog = flag
        },
        setSearchDialog: function (state, flag) {
            state.searchDialog = flag
        },
        setCourierInfo: function (state, courierInfoData) {
            state.courierInfo = courierInfoData
        },
        setLogin: function (state , loginData) {
            state.login = loginData;
        },
        setlistForExchange: function (state, listForExchangeData) {
          state.listForExchange = listForExchangeData
        },
        setCourses: function (state, coursesData)  {
            state.courses = coursesData
        },
        setSemesters: function (state, semesterData) {
            state.semesters = semesterData
        },
        setListOfBooksById: function (state, listOfBooksByIdData) {
            state.listOfBooksById = listOfBooksByIdData
        },
        setListOfEbooksById: function (state , listOfEbooksByIdData) {
            state.listOfEbooksById = listOfEbooksByIdData
        },
        setSemesterCoursesArray: function (state, semesterCoursesArrayData) {
            state.semesterCoursesArray = semesterCoursesArrayData
        },
        setSemesterData: function (state, allSemesterData) {
            state.semesterData = allSemesterData
        },
        setCheckedBooks: function (state , checkedBooksData) {
            state.checkedBooks = checkedBooksData
        },
        setStatement: function (state , statementData) {
            state.statement = statementData
        },
        setPoints: function (state , pointsData) {
            state.points = pointsData
        },
        setMatch: function (state, matchData) {
            state.match = matchData
        },
        setCourier: function (state, courierData) {
            state.courier = courierData
        },
        setActive: function (state, activeData) {
            state.active = activeData
        },
        setPinFlag: function (state, pinFlagData) {
            state.pinFlag = pinFlagData
        },
        setStatementBookGroup: function (state, statementBookGroupData) {
            state.statementBookGroup = statementBookGroupData
        },
        setExchangeType: function (state, exchangeTypeData) {
            state.exchangeType = exchangeTypeData
        },
        setCourierInfoFlag: function (state, courierInfoFlagData) {
            state.courierInfoFlag = courierInfoFlagData
        },
        setFinalDeclarationflag: function (state, finalDeclarationflagData) {
            state.finalDeclarationflag = finalDeclarationflagData
        },
        setChooseCourierButton: function (state, chooseCourierButtonData) {
            state.chooseCourierButton = chooseCourierButtonData
        },
        setLoadingModal: function (state, loadingModalData) {
            state.loadingModal = loadingModalData
        },
        setBookExchangeFlag: function (state, bookExchangeFlagData) {
            state.bookExchangeFlag = bookExchangeFlagData
        },
        setBookSelect: function (state, bookSelectData) {
            state.bookSelect = bookSelectData
        },
        setExchangeStudentData: function (state, exchangeStuden_tData) {
            state.exchangeStudentData = exchangeStuden_tData
        },
        setListOfExchangeBooks: function (state, listOfExchangeBooksData) {
            state.listOfExchangeBooks = listOfExchangeBooksData
        },
        setActiveDeclaration: function (state, activeDeclarationData) {
            state.activeDeclaration = activeDeclarationData
        },
        setStatementComplete: function (state, statementCompleteData) {
            state.statementComplete = statementCompleteData
        },
        setRedeemPoints: function (state, redeemPointsData) {
            state.redeemPoints = redeemPointsData
        },
        setAvaliableCredit: function (state, avaliableCreditData) {
            state.avaliableCredit= avaliableCreditData
        },
        setMessageModal: function (state, messageModalData) {
            state.messageModal = messageModalData
        },
        setBookInfoModal: function (state, bookInfoModalData) {
            state.bookInfoModal = bookInfoModalData
        },
        setTooltipBookId: function (state, tooltipBookIdData) {
            state.tooltipBookId = tooltipBookIdData
        },
        setMessageObject: function (state, messageObjectData) {
            state.messageObject = messageObjectData
        },
        setErrorMessageModal: function (state, errorMessageModalData){
          state.errorMessageModal = errorMessageModalData
        },
        setErrorMessageObject: function (state, errorMessageObjectData) {
            state.errorMessageObject = errorMessageObjectData
        },
        setBooksFromCheckedBySecretariat: function (state, booksFromCheckedBySecretariatData) {
            state.booksFromCheckedBySecretariat = booksFromCheckedBySecretariatData
        },
        setBooksFromCheckedByDistPoint: function (state, booksFromCheckedByDistPointData) {
            state.booksFromCheckedByDistPoint = booksFromCheckedByDistPointData
        },
        setBooksFromCheckedByCourrier: function (state, booksFromCheckedByCourrierData) {
            state.booksFromCheckedByCourrier = booksFromCheckedByCourrierData
        },
        setBooksFromRedeemBySecretariat: function (state,booksFromRedeemBySecretariatData) {
            state.booksFromRedeemBySecretariat = booksFromRedeemBySecretariatData
        },
        setBooksFromRedeemByDistPoint: function (state, booksFromRedeemByDistPointData) {
            state.booksFromRedeemByDistPoint = booksFromRedeemByDistPointData
        },
        setBooksFromRedeemByCourrier: function (state, booksFromRedeemByCourrierData) {
            state.booksFromRedeemByCourrier = booksFromRedeemByCourrierData
        },
        setInitializationFlag: function (state, initializationFlagData) {
            state.initializationFlag = initializationFlagData
        },
        setCounterDelivered: function (state, counterDeliveredData){
            state.counterDelivered = counterDeliveredData
        },
        setTotalWronglyDeliveredBooks: function (state, data){
            state.totalWronglyDeliveredBooks = data
        },
        setCounterReturnedToLibrary: function  (state, counterReturnedToLibraryData){
            state.counterReturnedToLibrary = counterReturnedToLibraryData
        },
        setCounterPassedToStudent: function (state, counterPassedToStudentData){
            state.counterPassedToStudent = counterPassedToStudentData
        },
        setCounterExchangeable: function  (state, counterExchangeableData) {
            state.counterExchangeable = counterExchangeableData
        },
        setStatementIsComplete: function (state, statementIsCompleteData) {
            state.statementIsComplete =  statementIsCompleteData
        },
        setSelected: function (state, selectedData) {
            state.selected = selectedData
        },
        setLinkedSemesterData: function (state, linkedSemesterDataOfData) {
            state.linkedSemesterData = linkedSemesterDataOfData
        },
        setListLinkedEbooks: function (state, listLinkedEbooksData) {
            state.listLinkedEbooks = listLinkedEbooksData
        },
        setSubmitInformationDialog: function (state, submitInformationDialogData) {
            state.submitInformationDialog = submitInformationDialogData
        },
        setBookExchange: function (state,bookExchangeData) {
            state.bookExchange = bookExchangeData
        },
        setSolarResponse: function (state, solarResponseData) {
            state.solarResponse = solarResponseData
        },
        setPendingEvaluationShow: function (state, pendingEvaluationShowData) {
            state.pendingEvaluationShow = pendingEvaluationShowData
        },
        setExchangeTypeComponentFlag: function (state, exchangeTypeComponentFlagData) {
            state.exchangeTypeComponentFlag = exchangeTypeComponentFlagData
        },
        setCourseRegistration: function (state, courseRegistrationData) {
            state.courseRegistration = courseRegistrationData
        },
        setStudentAddressInformation: function (state, studentAddressInformationData) {
            state.studentAddressInformation = studentAddressInformationData
        },
        setStatementAddress: function (state, statementAddressData) {
            state.statementAddress = statementAddressData
        },
        setCourseCodeHashMap: function (state, courseCodeHashMapData) {
            state.courseCodeHashMap = courseCodeHashMapData
        },
        setVouchersDialog: function (state, data) {
            state.vouchersDialog = data
        },
        setNewIssueDialog: function (state, data) {
            state.newIssueDialog = data
        },
    },

    actions: {
        setCheckedTerms: function ({commit}, flag) {
            commit('setCheckedTerms', flag)
        },
        setCheckedDegree: function ({commit}) {
            commit('setCheckedDegree')
        },
        setCertificateDialog: function ({commit}) {
            commit('setCertificateDialog')
        },
        setExchangeDialog: function ({commit}) {
            commit('setExchangeDialog')
        },
        setFullName: function ({commit}) {
            commit('setFullName')
        }
    }
})
